/**
 * Generic Model.
 */
export default class Collection {

    constructor(dataKey = 'data'){
        this._dataKey = dataKey;
      // return  new Proxy(this, {
      //       // Modifying the get function on handler
      //       get: function (target, name) {
      //           // Checking if the name is a numeric reference
      //           if (typeof name === 'string' && /^-?\d+$/.test(name)) {
      //
      //               return target.data[name];
      //           }
      //           else {
      //               // otherwise we are looking at a direct reference, maybe to a method or scope variable, like random.method()
      //               return target[name]
      //           }
      //       }
      //   })
    }

    get length(){
        return this[this._dataKey].length
    }




}


// WEBPACK FOOTER //
// ../hasta-la-vista-middleware-api/src/model/Collection.js